import { render, staticRenderFns } from "./gifCompress.vue?vue&type=template&id=70d57971"
import script from "./gifCompress.vue?vue&type=script&lang=js"
export * from "./gifCompress.vue?vue&type=script&lang=js"
import style0 from "./gifCompress.vue?vue&type=style&index=0&id=70d57971&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports